import * as types from './mutation-types'

export default {
    [types.CREATE_QUIZ] (state, quiz) {
        state.quiz = [...state.quiz, quiz]
    },
    [types.CREATE_QUESTION] (state, question) {
        let quiz = state.quiz

        for (let i in quiz) {
            if (quiz[i].id === question.quizId) {
                quiz[i].questions.push(question)
            }
        }
        state.quiz = quiz
    },
}
